var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78516 17.4319H6.92801C7.04587 17.4319 7.1423 17.3355 7.1423 17.2176V4.78906C7.1423 4.67121 7.04587 4.57478 6.92801 4.57478H4.78516C4.6673 4.57478 4.57087 4.67121 4.57087 4.78906V17.2176C4.57087 17.3355 4.6673 17.4319 4.78516 17.4319ZM9.92801 9.93192H12.0709C12.1887 9.93192 12.2852 9.83549 12.2852 9.71763V4.78906C12.2852 4.67121 12.1887 4.57478 12.0709 4.57478H9.92801C9.81016 4.57478 9.71373 4.67121 9.71373 4.78906V9.71763C9.71373 9.83549 9.81016 9.93192 9.92801 9.93192ZM15.0709 11.8605H17.2137C17.3316 11.8605 17.428 11.7641 17.428 11.6462V4.78906C17.428 4.67121 17.3316 4.57478 17.2137 4.57478H15.0709C14.953 4.57478 14.8566 4.67121 14.8566 4.78906V11.6462C14.8566 11.7641 14.953 11.8605 15.0709 11.8605ZM20.8566 0.289062H1.1423C0.668192 0.289062 0.285156 0.672098 0.285156 1.14621V20.8605C0.285156 21.3346 0.668192 21.7176 1.1423 21.7176H20.8566C21.3307 21.7176 21.7137 21.3346 21.7137 20.8605V1.14621C21.7137 0.672098 21.3307 0.289062 20.8566 0.289062ZM19.7852 19.7891H2.21373V2.21763H19.7852V19.7891Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.793235d0712bf3adfb4747167becb6bf.svg";
export { ForwardRef as ReactComponent };